import React from 'react';
import { Icon } from '@livable/saas-react-components';
import { Box, Button, ButtonBase, IconButton } from '@mui/material';
import useStyles from './billsFilterPanelStyles';

/**
 * The filters in use, under the search box (LB-6087). It used to be two small dots, which said a filter was on but not
 * which, so a list narrowed to nothing read as a company with no bills.
 *
 * A chip names its filter and what is picked in it; clicking it opens the panel at that filter, and its × takes the
 * filter off. Two separate controls rather than a chip with a delete icon, so each has a name of its own.
 */
export function BillsFilterChips(_ref) {
  let chips = _ref.chips,
    onClearAll = _ref.onClearAll,
    onOpen = _ref.onOpen,
    onRemove = _ref.onRemove;
  const classes = useStyles();
  if (!chips.length) return null;
  return /*#__PURE__*/React.createElement(Box, {
    className: classes.chipsRow,
    role: "group",
    "aria-label": "Filters in use"
  }, chips.map(chip => /*#__PURE__*/React.createElement(Box, {
    component: "span",
    key: chip.key,
    className: classes.chip
  }, /*#__PURE__*/React.createElement(ButtonBase, {
    className: classes.chipLabel,
    title: "".concat(chip.label, ": ").concat(chip.text),
    onClick: () => onOpen(chip.key)
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.chipName
  }, chip.label, ":"), " ", chip.text), /*#__PURE__*/React.createElement(IconButton, {
    size: "small",
    className: classes.chipRemove,
    "aria-label": "Remove the ".concat(chip.label, " filter"),
    onClick: () => onRemove(chip.key)
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "close"
  })))), /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    size: "small",
    className: classes.clearAllButton,
    onClick: onClearAll
  }, "Clear all"));
}